import React, { FunctionComponent } from 'react'
import { ConflictItem } from '../../entities/ConfigurationResponse'
import { Checkbox } from '../form'
import MediaImg from '../media-img'
import useTranslation from '../../hooks/useTranslation'
import style from './foresightedBuildabilityConflictStepItem.css'
import InfoButton from '../info-button'
import InfoI from '../info-i'
import { Markup } from 'interweave'

export type Props = {
    item: ConflictItem
    checkboxIsChecked: boolean
    checkboxIsVisible: boolean
    checkboxIsDisabled: boolean
    openInfoModal: Function
    selectEquipment: Function
    deselectEquipment: Function
    hideBuildabilityConflictLabel: boolean
}

const ForesightedBuildabilityConflictStepItem: FunctionComponent<Props> = (props) => {
    const {
        item,
        checkboxIsChecked,
        checkboxIsVisible,
        checkboxIsDisabled,
        openInfoModal,
        deselectEquipment,
        selectEquipment,
        hideBuildabilityConflictLabel,
    } = props
    const { t } = useTranslation()
    const { id, name, evaKey, price, media, content } = item.equipment

    const openModal =
        (activeMedia: string | null = null) =>
        () =>
            openInfoModal({
                title: name,
                media,
                activeMedia,
                content,
            })

    const infoIsForced = media && media.find((mediaItem) => mediaItem.forced) !== undefined

    const changeHandler = (): void => {
        if (checkboxIsChecked) {
            deselectEquipment(id)
        } else {
            const infoModal = infoIsForced
                ? {
                      title: name,
                      media,
                      content,
                  }
                : undefined
            selectEquipment(id, { infoModal })
        }
    }

    const checkboxElement = checkboxIsVisible ? (
        <span>
            <Checkbox checked={checkboxIsChecked} disabled={checkboxIsDisabled} onChange={changeHandler} />
        </span>
    ) : null

    const label = t(
        item.conflictType === 'ADD' ? 'foresightedBuildabilityModal.plus' : 'foresightedBuildabilityModal.minus',
    )

    const hasImgInfo = media && media.length > 0
    const imgElement = hasImgInfo ? <MediaImg alt={name} media={media} width={100} /> : null
    const infoLabel = imgElement !== null ? imgElement : <InfoI isForced={false} />
    const infoElement = hasImgInfo ? (
        <InfoButton openModal={openModal(imgElement !== null ? 'image' : null)} dataTestId={id}>
            {infoLabel}
        </InfoButton>
    ) : (
        <div className={style.imagePlaceholder}></div>
    )

    const hasInfo = (media && media.length > 0) || (content && content.length > 0)

    const className = [style.container, checkboxIsVisible ? style.containerWithCheckbox : ''].join(' ')

    const infoButtonElement = hasInfo ? (
        <div className={style.info}>
            <InfoButton openModal={openModal()} dataTestId={`info-button-${id.replace(/\\/g, '.')}`}>
                <InfoI isForced={infoIsForced} />
            </InfoButton>
        </div>
    ) : (
        <div className={style.infoPlaceholder}></div>
    )

    return (
        <div className={className}>
            {checkboxElement}
            <div className={style.labelAndName}>
                {!hideBuildabilityConflictLabel && (<span className={style.label}>{label}</span>)}
                <span>
                    {' '}
                    <Markup content={name} />{' '}
                </span>
            </div>
            <span>{infoElement}</span>
            <span className={style.evaKey}>{evaKey}</span>
            <div className={style.priceAndInfo}>
                {price ? (
                    <span className={style.price}>{price}</span>
                ) : (
                    <span className={style.pricePlaceholder}></span>
                )}
                {infoButtonElement}
            </div>
        </div>
    )
}

export default ForesightedBuildabilityConflictStepItem
